<template>
	<div>
		<el-skeleton :rows="8" :loading="loadingMask" animated >
			<div v-if="origindingyuecount" class="zjjb"><!-- zjjb -->
				<ul class="title1">
					<li class="L">专题订阅</li>
					<li class="M"></li>
					<li class="R"><btn  class="btn_manage" name="D_SubscribeManage" @click="guanlishow=true" style="text-decoration: none;">管理</btn></li>
					<li class="R"><btn  class="btn_change" name="D_SubscribeManage" @click="changetuijian" style="text-decoration: none;">换一换</btn></li>
				</ul>
				<el-skeleton :rows="8" :loading="loadingMask_change" animated :throttle="500" >
				<div  class="group1 "><!-- group1 -->
					<div  class="group1_L w_50"><!-- group1_L -->
						
						<ul  class="list1"  >
							<li v-for="(item,index) in articlesList" v-if="index<5"><a @click="jumppush('/detail/'+item.id+'?col=tuijian')" target="_blank">{{item.title}}</a></li>
						</ul>
						
			
					</div><!-- /group1_L -->
					<div  class="group1_R w_50"><!-- group1_R -->
						
						<ul  class="list1"  >
							<li v-for="(item,index) in articlesList" v-if="index>4&&index<10"><a @click="jumppush('/detail/'+item.id+'?col=tuijian')" target="_blank">{{item.title}}</a></li>
						</ul>
						
						
					</div><!-- /group1_R -->
				</div><!-- /group1 -->
				</el-skeleton>
			</div><!-- /zjjb -->
			
			<div v-else class="recommend_none">
				<img src="/images/unsubscribed_img.png" alt=""/>
				<h5>您还未订阅任何标签，赶快去订阅您感兴趣的标签吧</h5>
				<div class="m_b1"></div>
				<btn class="s_btn" @click="guanlishow=true"  >立即订阅</btn>
				
			</div>
		</el-skeleton>
		
		
		<div class="Subscribe_Manage _popRight" id="SubscribeManage_pop" style="display: block;" v-show="guanlishow"><!-- trial_apply -->
			<div class="pop_right"><!-- pop_right -->
				<ul class="pop_right_header2">
					<li><h2>专题订阅管理</h2></li>
					<li><btn class="pop_right_close2" name="pop-close" @click="cancelGuanliPanel"></btn></li>
				</ul>
				<div class="pop_right_main"><!-- main -->
			
						<h3>专题</h3>
						<ul class="group3b">
							<li v-for="(item,index) in zhuantiList" class="group3b_item">
								<div @click="showSelectPanel(item.columnid,$event)" @blur="hideSelectPanel" tabindex="99" class=" cei-select select_sty1" name="cei-select" style="width:100%">
									<i class="cei-icon" :class="{'icon-arrup icon-arrow-on':selectedactive==item.columnid,'icon-arrdown':selectedactive!=item.columnid}"></i>
									<div class="inpout" >
										<dot :style="{'background':((selectedactive==item.columnid||dingyueList[index].length)?'#bd1a2d!important':'#a1a4ab')}"></dot>
										<name :class="{'red':dingyueList[index].length}" >{{item.columnname}}</name>
										<numbers v-show="dingyueList[index].length">+{{dingyueList[index].length}}</numbers>
									</div>
									<figure v-show="selectedactive==item.columnid" class="MyTabs Mulchoice_list_out"><!-- MyTabs -->
									  	<el-checkbox-group v-model="dingyueList[index]">
									  		<el-checkbox v-for="(subitem,subindex) in item.Child" :label="subitem.columnid">{{subitem.columnname}}</el-checkbox>
									  	</el-checkbox-group>
									</figure><!-- /MyTabs -->		
								</div>
							</li>
						</ul>
						
				</div><!-- /main -->
				<div class="pop_right_footer2">
						<btn class="s_btn" @click="saveUserOrders"  >确定</btn>
				</div>
			</div><!-- /pop_right -->
			<div class="pop_bg" style="display: block;" @click="cancelGuanliPanel"></div>
		</div><!-- /trial_apply -->
	</div>
	
</template>

<script>
	export default{
		data() {
			return {
				hasPower:true,
				loadingMask:true,
				loadingMask_change:false,
				guanlishow: false,
				articlesList:[],
				dingyueList:[],
				origindingyueList:[],
				origindingyuecount:0,
				colidstring:'',
				zhuantiList:[],
				selectedactive:'',
				tuijianpage:'1',
			}
		},
		mounted:function(){
			this.getAllUserOrder();
			
		},
		methods:{
			authcheck:function(){
				// this.hasPower=false;
				// if(!this.$cookies.get('userauth')){
				// 	this.hasPower=true;
				// }
				// else{
				// 	if(this.$cookies.get('userauth')=='1921f9e1416473a1d0f15d328e837115'){
				// 		this.hasPower=true;
				// 	}
				// 	if(this.$cookies.get('userauth').indexOf('tuijian')>-1){
				// 		this.hasPower=true;
				// 	}
				// }
			},
			jumppush:function(to){
				this.authcheck();
				if(!this.hasPower){
					alert('您未购买此栏目!');
					return false;
				}
				else{
					var a = document.createElement('a');
					a.setAttribute('href', to);
					a.setAttribute('style', 'display:none');  
					a.setAttribute('target', '_blank');  
					document.body.appendChild(a);
					a.click();
					a.parentNode.removeChild(a); 
				}
			},
			getDingyueArticles:function(){
				let _this = this;
				// _this.loadingMask = true;
				this.$http({
						method: 'get',
						url: 'recommend/getSubscribeArticles',
						responseType: 'json',
						params: {
							userid:this.$cookies.get('userinfo')?this.$cookies.get('userinfo').userAccountID:'',
							iPage:this.tuijianpage,
							pageSize:'10',
						},
					})
					.then(function(response) {
						_this.articlesList=response.data.data.data.data
						_this.loadingMask = false;
						_this.loadingMask_change = false;
					})
					.catch(function(error) {
						_this.loadingMask = false;
						_this.loadingMask_change = false;
						console.log(error);
					});
			},
			changetuijian:function(){
				this.tuijianpage=this.tuijianpage=='1'?'2':'1';
				this.loadingMask_change = true;
				this.getDingyueArticles();
			},
			hideSelectPanel:function(evnet){
				this.selectedactive='';
				// console.log('blur'+this.selectedactive);
			},
			showSelectPanel:function(id,event){
				// console.log(event.target.tagName+' '+event.target.className);
				// if(event.target.tagName!='DIV'&&event.target.tagName!='NAME'&&event.target.tagName!='NUMBERS'&&event.target.tagName!='I'){
				// 	// event.preventDefault();
				// 	return false;
				// }
				// if(event.target.className.indexOf('el-checkbox')>-1){
				// 	return false;
				// }
				if(this.selectedactive==id){
					if(event.target.tagName=='FIGURE'||event.target.className=='el-checkbox-group'){
						return false;
					}
					// if(event.target.tagName=='NAME'||event.target.tagName=='NUMBERS'||event.target.tagName=='I'){
					// 	this.selectedactive='';
					// }
					this.selectedactive='';
				}
				else{
					this.selectedactive=id;
				}
				// console.log(this.selectedactive);
			},
			// getAllOrderCol:function(){
			// 	let _this = this;
			// 	_this.loadingMask = true;
			// 	this.$http({
			// 			method: 'get',
			// 			url: 'UserInfo/selectAllOrderCol',
			// 			responseType: 'json',
			// 			params: {
							
			// 			},
			// 		})
			// 		.then(function(response) {
			// 			_this.zhuantiList = response.data.data.data;
			// 			_this.loadingMask = false;
			// 		})
			// 		.catch(function(error) {
			// 			_this.loadingMask = false;
			// 			console.log(error);
			// 		});
			// },
			getAllUserOrder:function(){
				let _this = this;
				// _this.loadingMask = true;
				this.$http({
						method: 'get',
						url: 'UserInfo/selectAllUserOrder',
						responseType: 'json',
						params: {
							
						},
					})
					.then(function(response) {
						var tempdata=response.data.data.data;
						for(var i=0;i<tempdata.length;i++){
							var tempchild=[];
							for(var j=0;j<tempdata[i].Child.length;j++){
								if(tempdata[i].Child[j].Child&&tempdata[i].Child[j].Child.length>0){
									for(var k=0;k<tempdata[i].Child[j].Child.length;k++){
										tempdata[i].Child[j].Child[k].columnname=tempdata[i].Child[j].columnname+'-'+tempdata[i].Child[j].Child[k].columnname;
									}
									tempchild=tempchild.concat(tempdata[i].Child[j].Child);
								}
							}
							if(tempchild.length>0){
								tempdata[i].Child=tempchild;
							}
						}
						var dingyuedata=tempdata;
						_this.origindingyueList=[];
						_this.origindingyuecount=0;
						for(var i=0;i<dingyuedata.length;i++){
							_this.origindingyueList.push([]);
							for(var j=0;j<dingyuedata[i].Child.length;j++){
								if(dingyuedata[i].Child[j].ordertype=="1"){
									_this.origindingyueList[i].push(dingyuedata[i].Child[j].columnid);
									_this.origindingyuecount++;
								}
							}
						}
						_this.dingyueList = JSON.parse(JSON.stringify(_this.origindingyueList));
						_this.zhuantiList = dingyuedata;
						// _this.loadingMask = false;
						_this.tuijianpage='1';
						_this.getDingyueArticles();
					})
					.catch(function(error) {
						// _this.loadingMask = false;
						console.log(error);
					});
			},
			saveUserOrders:function(){
				this.colidstring='';
				for(var i=0;i<this.dingyueList.length;i++){
					if(this.dingyueList[i].length>0){
						if(this.colidstring){
							this.colidstring+=',';
						}
						this.colidstring+=this.dingyueList[i].join(',');
					}
				}
				let _this = this;
				_this.loadingMask = true;
				this.$http({
						method: 'post',
						url: 'UserInfo/SaveUserOrders',
						responseType: 'json',
						params: {
							ColID:this.colidstring
						},
					})
					.then(function(response) {
						if(response.data.data.data.code=='0'){
							_this.$track([
								['pagetype','订阅修改'],
								['reqtype','3'],
								['column',_this.colidstring.replace(/,/g,' ')]
							]);
							_this.$message({
								message: '订阅修改成功',
								type: 'success'
							});
							_this.guanlishow=false;
							_this.getAllUserOrder();
						}
						_this.loadingMask = false;
					})
					.catch(function(error) {
						_this.loadingMask = false;
						console.log(error);
					});
			},
			cancelGuanliPanel:function(){
				this.guanlishow=false;
				this.dingyueList = JSON.parse(JSON.stringify(this.origindingyueList));
				// for(var i=0;i<this.origindingyueList.length;i++){
				// 	this.$set(this.dingyueList[i],'selected',this.origindingyueList[i].selected);
				// }
				// console.log(this.dingyueList);
			}
		}
	}
</script>

<style>
	.Subscribe_Manage .MyTabs.Mulchoice_list_out{
		z-index: 3;
		line-height: 26px;
	}
	.Subscribe_Manage .el-checkbox{
/* 		float: left;
		clear: both; */
		width: 100%;
		margin-bottom: 8px;
	}
	.Subscribe_Manage .el-checkbox .el-checkbox__label{
		font-size: 16px;
	}
	.Subscribe_Manage .el-checkbox__input.is-checked .el-checkbox__inner{
		background-color: #bd1a2d;
		border: 1px solid #bd1a2d;
	}
	.Subscribe_Manage .el-checkbox__input.is-checked+.el-checkbox__label{
		color: #606266;
	}
	.btn_change { display:flex; align-items: center;white-space:nowrap; }
	.btn_change:after { content:""; display: inline-block;width:16px; height:16px; background: url("/images/icon_change.png") no-repeat  ; margin-left: 8px;  } 
	.btn_change:hover {color:#bd1a2d;text-decoration: underline } 
</style>
